<!-- src/ChapterList.vue -->
<!-- Lists chapters newest first. size="compact" for the home page, size="large" (adds description + page count) for the chapters page. -->

<template>
  <section>
    <div v-if="loading" class="text-center p-4 textmain d-flex align-items-center justify-content-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div v-else-if="error" class="text-center p-4">
      <p class="text-danger">{{ error }}</p>
    </div>
    <div v-else-if="chapters.length === 0" class="text-center p-4">
      <p class="textlightgray">No chapters yet</p>
    </div>

    <!-- One card per chapter. Same layout on both pages; the chapters page adds the description and page count. -->
    <div v-else class="d-flex flex-column gap-2" :class="{ 'p-2': size === 'compact' }">
      <article
        v-for="chapter in chapters"
        :key="chapter.ChapterNumber"
        class="chapter-card dark-gray-box-1 d-flex flex-column text-start p-2"
      >
        <router-link :to="chapterLink(chapter)" class="text-decoration-none">
          <h6 class="MainTitleFont textmain textmainhover text-nowrap m-0">Chapter {{ chapter.ChapterNumber }}</h6>
        </router-link>
        <p v-if="chapter.Name" class="textlightgray mb-1">{{ chapter.Name }}</p>
        <i><p v-if="size === 'large' && chapter.Description" class="textlightgray small mb-1">{{ chapter.Description }}</p></i>
        

        <div class="d-flex align-items-end justify-content-between gap-2 mt-auto">
          <small class="textlightgray">
            {{ formatChapterDate(chapter.Date) }}<template v-if="size === 'large'"> · {{ chapter.lastPage + 1 }} pages</template>
          </small>
          <router-link :to="chapterLink(chapter)" class="btn btn-sm btn-read">Read</router-link>
        </div>
      </article>
    </div>
  </section>
</template>

<style scoped>
.chapter-card {
  transition: transform 0.2s ease, border-color 0.2s ease;
}
.chapter-card:hover {
  transform: translateY(-2px);
  border-color: var(--main-text-color, #ff0000);
}
.btn-read {
  background-color: var(--main-text-color, #ff0000);
  border-color: var(--main-text-color, #ff0000);
  color: var(--purewhite, #ffffff);
  font-weight: 600;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  flex-shrink: 0;
}
.btn-read:hover,
.btn-read:focus-visible {
  background-color: var(--main-hover-color, #d40000);
  border-color: var(--main-hover-color, #d40000);
  color: var(--purewhite, #ffffff);
}
</style>

<script>
import { fetchChapters, formatChapterDate } from '@/chapterApi.js';

export default {
  name: 'ChapterList',
  props: {
    size: { type: String, default: 'large' }, // 'compact' or 'large'
    limit: { type: Number, default: 0 },      // 0 = every chapter
  },
  data() {
    return {
      chapters: [],
      loading: true,
      error: null,
    };
  },
  created() {
    fetchChapters(this.limit)
      .then(data => {
        this.chapters = data;
      })
      .catch(error => {
        console.error('Error fetching chapters:', error);
        this.error = 'Could not load chapters';
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    formatChapterDate,
    chapterLink(chapter) {
      return { name: 'ChapterPage', params: { id: chapter.ChapterNumber } };
    },
  },
};
</script>
